export default "__VITE_ASSET__B$GF7h5V__"